import { render, staticRenderFns } from "./MobileInstallGuide.vue?vue&type=template&id=36aec4fa&scoped=true"
import script from "./MobileInstallGuide.vue?vue&type=script&lang=js"
export * from "./MobileInstallGuide.vue?vue&type=script&lang=js"
import style0 from "./MobileInstallGuide.vue?vue&type=style&index=0&id=36aec4fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aec4fa",
  null
  
)

export default component.exports